import { oidcOnAppSettingsFile } from '../administration/ADFSConfig/DomainUtils';

/** Must match how Salg compares schemes. */
export const normaliseScheme = (scheme: string | null | undefined) => (scheme ?? '').replace(/[^A-Za-z0-9æøåÆØÅ]/g, '').toLowerCase();

/** ASCII only: it ends up in URLs, claims and a callback path. */
export const isValidScheme = (scheme: string) => /^[A-Za-z0-9]+$/.test(scheme);

export const isReservedScheme = (scheme: string) => oidcOnAppSettingsFile.includes(normaliseScheme(scheme));

const LEGAL_FORMS = new Set(['as', 'asa', 'ans', 'da', 'sa', 'ab', 'kf', 'iks', 'nuf', 'ltd', 'gmbh', 'inc', 'llc', 'bv', 'oy', 'aps']);

const transliterate = (text: string) =>
  text
    .replace(/æ/g, 'ae')
    .replace(/Æ/g, 'Ae')
    .replace(/ø/g, 'oe')
    .replace(/Ø/g, 'Oe')
    .replace(/å/g, 'aa')
    .replace(/Å/g, 'Aa')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '');

export function schemeFromCompanyName(companyName: string | null | undefined, taken: string[]): string {
  const words = transliterate(companyName ?? '')
    .split(/[^A-Za-z0-9]+/)
    .filter((word) => word && !LEGAL_FORMS.has(word.toLowerCase()));
  const base = words
    .map((word) => (word === word.toUpperCase() || word === word.toLowerCase() ? word[0].toUpperCase() + word.slice(1).toLowerCase() : word))
    .join('');
  if (!base) return '';

  const used = new Set(taken.map(normaliseScheme));
  if (!used.has(normaliseScheme(base)) && !isReservedScheme(base)) return base;
  for (let n = 2; ; n++) {
    const candidate = `${base}${n}`;
    if (!used.has(normaliseScheme(candidate))) return candidate;
  }
}
